export default __webpack_public_path__ + "static/media/work2.a2811c87.jpg";